function focusCreateVorgangschrittDialog(root) {
    const textarea = root.querySelector('[data-role="external-description"]');
    const closeButton = root.querySelector(".ct-dialog-close");

    if (textarea instanceof HTMLElement) {
        textarea.focus();
        return;
    }

    closeButton?.focus();
}

function openCreateVorgangschrittDialog(root) {
    const dialog = root.querySelector('[data-role="dialog"]');
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) {
        return;
    }

    const openButton = root.querySelector('[data-action="open-dialog"]');
    if (openButton instanceof HTMLElement) {
        root.dataset.returnFocusId = openButton.id;
    }

    dialog.showModal();
    window.setTimeout(() => focusCreateVorgangschrittDialog(root), 1);
}

function closeCreateVorgangschrittDialog(root) {
    const dialog = root.querySelector('[data-role="dialog"]');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) {
        return;
    }

    dialog.close();

    const returnFocusId = root.dataset.returnFocusId;
    if (!returnFocusId) {
        return;
    }

    const returnFocusElement = root.querySelector(`#${CSS.escape(returnFocusId)}`);
    if (returnFocusElement instanceof HTMLElement) {
        returnFocusElement.focus();
    }
}

function updateCreateVorgangschrittSubmitState(root) {
    const textarea = root.querySelector('[data-role="external-description"]');
    const submitButton = root.querySelector('[data-role="submit-button"]');
    if (!(textarea instanceof HTMLTextAreaElement) || !(submitButton instanceof HTMLButtonElement)) {
        return;
    }

    const isValid = textarea.validity.valid;

    submitButton.disabled = !isValid;
    submitButton.setAttribute("aria-disabled", String(!isValid));
    submitButton.classList.toggle("disabled", !isValid);
    submitButton.tabIndex = isValid ? 0 : -1;
}

function focusCreateVorgangschrittErrors(root) {
    const error = root.querySelector(".validation-summary-errors, .field-validation-error");
    if (!(error instanceof HTMLElement)) {
        return;
    }

    openCreateVorgangschrittDialog(root);

    window.setTimeout(() => {
        const invalidField = root.querySelector(":invalid");
        const focusTarget = invalidField instanceof HTMLElement
            ? invalidField
            : root.querySelector('[data-role="validation-summary"]');

        error.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });

        if (focusTarget instanceof HTMLElement) {
            focusTarget.focus();
        }
    }, 50);
}

function initTicketsCreateVorgangschritt(root) {
    if (root.dataset.createVorgangschrittInitialized === "true") {
        return;
    }

    updateCreateVorgangschrittSubmitState(root);
    focusCreateVorgangschrittErrors(root);

    root.addEventListener("click", (event) => {
        const actionElement = event.target.closest("[data-action]");
        if (!actionElement || !root.contains(actionElement)) {
            return;
        }

        const action = actionElement.getAttribute("data-action");
        if (action === "open-dialog") {
            openCreateVorgangschrittDialog(root);
        }

        if (action === "close-dialog") {
            closeCreateVorgangschrittDialog(root);
        }
    });

    const dialog = root.querySelector('[data-role="dialog"]');
    if (dialog instanceof HTMLDialogElement) {
        dialog.addEventListener("click", (event) => {
            if (event.target === dialog) {
                closeCreateVorgangschrittDialog(root);
            }
        });

        dialog.addEventListener("cancel", (event) => {
            event.preventDefault();
            closeCreateVorgangschrittDialog(root);
        });
    }

    const textarea = root.querySelector('[data-role="external-description"]');
    textarea?.addEventListener("input", () => {
        updateCreateVorgangschrittSubmitState(root);
    });
    textarea?.addEventListener("change", () => {
        updateCreateVorgangschrittSubmitState(root);
    });

    root.dataset.createVorgangschrittInitialized = "true";
}

export function initTicketsCreateVorgangschrittComponents(root = document) {
    root.querySelectorAll("[data-create-vorgangschritt]").forEach((componentRoot) => {
        initTicketsCreateVorgangschritt(componentRoot);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTicketsCreateVorgangschrittComponents);
} else {
    initTicketsCreateVorgangschrittComponents();
}
